import { frameworkPlayerMessage } from "../../../core/components/playerMessage/configuration/playerMessageconfiguration"
import React from "react";


frameworkPlayerMessage.data = {
    "leftContainerInterval": 4000,
    "rightContainerInterval": 2000,
    "COMPONENTS": [
        {
            "id": "GamePlayerMessageContainer",
            "name": "GamePlayerMessageContainer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "parentLayer": "baseLayer",
            child: [
                {
                    "id": "GamePlayerMessageComponent",
                    "name": "GamePlayerMessage",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: [



                        {
                            id: "container_label",
                            "name": "container_basegame_text1",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": false,
                            "uimode": "desktop",
                            "x": 1318,
                            "y": 1022,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [

                                {
                                    "id": "textOfContainer1_1",
                                    "name": "text_bet_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_1",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "textOfContainer1_2",
                                    "name": "text_colonSymbol1",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "textOfContainer1_3",
                                    "name": "text_total_bet_value",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_8",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },


                            ]

                        },


                        {
                            id: "container_label_balance_desktop",
                            "name": "container_basegame_text2",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": false,
                            "uimode": "desktop",
                            "x": 600,
                            "y": 1022,

                            "width": 500,
                            "height": 100,
                            "filterTypes": [],
                            child: [


                                {
                                    "id": "textOfContainer2_4",
                                    "name": "text_Balance_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 146,
                                    "visible": true,
                                    "text": "buttonPanelText_3",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "textOfContainer2_5",
                                    "name": "text_colonSymbol4",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 10,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "textOfContainer2_6",
                                    "name": "text_Balance_value_withSign",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "layout": false,
                                    "uimode": "desktop",
                                    "text": "buttonPanelText_16",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                            ]

                        },

                        {
                            id: "container_label",
                            "name": "container_basegame_text3",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": false,
                            "uimode": "desktop",
                            "x": 850,
                            "y": 1060,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [




                                {
                                    "id": "text_6",
                                    "name": "text_win_value1",
                                    "uimode": "desktop",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 300,
                                    "visible": true,
                                    "text": "0.00",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "textOfContainer1_2",
                                    "name": "text_colonSymbol1",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 100,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },


                                {
                                    "id": "textOfContainerTotalWin",
                                    "name": "text_totalwin_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 300,
                                    "visible": true,
                                    "text": "buttonPanelText_totalWin",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                            ]

                        },
                        {
                            id: "gameName_label_bottom",
                            "name": "gameName_label_bottom",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": false,
                            "uimode": "desktop",
                            "x": 40,
                            "y": 0,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [

                                {
                                    "id": "gameName_label_bottom",
                                    "name": "gameName_label_bottom",
                                    "type": "Text",
                                    "x": 1760,
                                    "y": 1063,
                                    "width": 500,
                                    "visible": true,
                                    "text": "INCA IDOLS",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "game_clock",
                                    "name": "game_clock",
                                    "type": "Text",
                                    "x": 74,
                                    "y": 1063,
                                    "width": 300,
                                    "visible": true,
                                    "text": "10.41",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "name": "brand_icon",
                                    "image": "brand_icon.png",
                                    "type": "Image",
                                    "class": "",
                                    "layout": true,
                                    "uimode": "mobile",
                                    "visible": true,
                                    "width": 24,
                                    "height": 25,
                                    "x": 1885,
                                    "y": 1049
                                },


                            ]

                        },





                        {
                            id: "container_label",
                            "name": "container_basegame_text1",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1318,
                            "y": 1022,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [

                                {
                                    "id": "textOfContainer1_1",
                                    "name": "text_bet_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_1",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "textOfContainer1_2",
                                    "name": "text_colonSymbol1",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "textOfContainer1_3",
                                    "name": "text_total_bet_value_landscape",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_8",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },


                            ]

                        },


                        {
                            id: "container_label_mobile_landscape",
                            "name": "container_basegame_text2",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 600,
                            "y": 1022,

                            "width": 500,
                            "height": 100,
                            "filterTypes": [],
                            child: [


                                {
                                    "id": "textOfContainer2_4",
                                    "name": "text_Balance_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 146,
                                    "visible": true,
                                    "text": "buttonPanelText_3",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "textOfContainer2_5",
                                    "name": "text_colonSymbol4",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 10,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "textOfContainer2_6",
                                    "name": "text_Balance_value_withSign_landscape",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "layout": false,
                                    "uimode": "desktop",
                                    "text": "buttonPanelText_16",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                            ]

                        },

                        {
                            id: "container_label",
                            "name": "container_basegame_text3",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 850,
                            "y": 1060,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [


                                {
                                    "id": "text_6",
                                    "name": "text_win_value1_landscape",
                                    "uimode": "desktop",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 300,
                                    "visible": true,
                                    "text": "0.00",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "textOfContainer1_2",
                                    "name": "text_colonSymbol1",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 100,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },


                                {
                                    "id": "textOfContainerTotalWin",
                                    "name": "text_totalwin_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 300,
                                    "visible": true,
                                    "text": "buttonPanelText_totalWin",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                }


                            ]

                        },
                        {
                            id: "gameName_label_bottom",
                            "name": "gameName_label_bottom",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 0,
                            "y": 0,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [

                                {
                                    "id": "gameName_label_bottom1",
                                    "name": "gameName_label_bottom1",
                                    "type": "Text",
                                    "x": 1760,
                                    "y": 1063,
                                    "width": 500,
                                    "visible": true,
                                    "text": "INCA IDOLS",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "game_clock",
                                    "name": "game_clock",
                                    "type": "Text",
                                    "x": 74,
                                    "y": 1063,
                                    "width": 300,
                                    "visible": true,
                                    "text": "10.41",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                /*    {
                                       "name": "brand_icon",
                                       "image": "brand_icon.png",
                                       "type": "Image",
                                       "class": "",
                                       "layout": true,
                                       "uimode": "mobile",
                                       "visible": true,
                                       "width": 24,
                                       "height": 25,
                                       "x": 1885,
                                       "y": 1049
                                   }, */


                            ]

                        },


                        {
                            "id": "label_BetPanel_value",
                            "name": "label_BetPanel_value",
                            "type": "Text",
                            "x": 275,
                            "y": 65,
                            "width": 300,
                            "visible": false,
                            "text": "£15.50",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 30,
                                fontWeight: 'bold',
                                fill: ['#ffffff'],
                            },
                        },





                        {
                            id: "container_label",
                            "name": "container_basegame_text1_portrait",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 0,
                            "y": 1022,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [

                                {
                                    "id": "textOfContainer1_1",
                                    "name": "text_bet_label",
                                    "type": "Text",
                                    "x": 1394,
                                    "y": 27,
                                    "width": 210,
                                    "visible": true,
                                    "text": "buttonPanelText_1",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "textOfContainer1_3",
                                    "name": "text_total_bet_value_portrait",
                                    "type": "Text",
                                    "x": 1392,
                                    "y": 68,
                                    "width": 300,
                                    "visible": true,
                                    "text": "buttonPanelText_8",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 30,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },


                            ]

                        },

                        {
                            id: "container_label",
                            "name": "container_basegame_text2_portrait",
                            "type": "Container",
                            "class": "",
                            "visible": true,
                            "messageInLoop": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 0,
                            "y": 1022,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [


                                {
                                    "id": "textOfContainer2_4",
                                    "name": "text_Balance_label",
                                    "type": "Text",
                                    "x": 450,
                                    "y": 27,
                                    "width": 166,
                                    "visible": true,
                                    "text": "buttonPanelText_3",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "textOfContainer2_6",
                                    "name": "text_Balance_value_withSign_portrait",
                                    "type": "Text",
                                    "x": 399,
                                    "y": 68,
                                    "width": 256,
                                    "visible": true,
                                    // "layout": false,
                                    // "uimode": "desktop",
                                    "text": "buttonPanelText_16",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 28,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                            ]

                        },
                        
                        {
                            id: "container_label_bet_coins",
                            "name": "container_basegame_text_bet_coins",
                            "type": "Container",
                            "class": "",
                            "visible": false,
                            "messageInLoop": true,
                            "layout": true,

                            "x": 1318,
                            "y": 1022,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [








                                {
                                    "id": "coinContainer_coins_value_text",
                                    "name": "coinContainer_coins_value_text",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "10",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_coins_separater",
                                    "name": "coinContainer_coins_separater",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": true,
                                    "text": ":",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_bet_coins_label",
                                    "name": "coinContainer_bet_coins_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "COINS",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer1_2",
                                    "name": "coinContainer_text_colonSymbol2",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer1_1",
                                    "name": "coinContainer_text_bet_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_1",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer1_2",
                                    "name": "coinContainer_text_colonSymbol1",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_textOfContainer1_3",
                                    "name": "coinContainer_text_total_bet_value",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "$1.22",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                            ]
                        },
                        {
                            id: "container_label_balance_landscape",
                            "name": "container_basegame_text_balance",
                            "type": "Container",
                            "class": "",
                            "visible": false,
                            "messageInLoop": true,


                            "x": 600,
                            "y": 1022,

                            "width": 500,
                            "height": 100,
                            "filterTypes": [],
                            child: [


                                {
                                    "id": "coinContainer_total_coins_label",
                                    "name": "coinContainer_total_coins_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 146,
                                    "visible": true,
                                    "text": "COINS",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer2_5",
                                    "name": "coinContainer_text_colonSymbol4",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 10,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer2_6",
                                    "name": "coinContainer_total_coins_value",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "layout": false,
                                    "uimode": "desktop",
                                    "text": "5000",
                                    "scaleToFit": true,
                                    "anchor": [1, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },



                            ]

                        },
                        {
                            id: "container_label_coins",
                            "name": "container_label_coins",
                            "type": "Container",
                            "class": "",
                            "visible": false,
                            "messageInLoop": true,
                            "x": 548,
                            "y": 1064,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [

                                {
                                    "id": "coinContainer_text_6",
                                    "name": "coinContainer_coin_win_value1_desktop",
                                    "uimode": "desktop",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 500,
                                    "visible": true,
                                    "text": "1",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_totalCoinwincolon",
                                    "name": "coinContainer_totalCoinwincolon",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": true,
                                    "text": ":",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_coinWinText",
                                    "name": "coinContainer_coinWinText",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "COINS",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_totalCoinwinSeparater",
                                    "name": "coinContainer_totalCoinwinSeparater1",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_text_6",
                                    "name": "coinContainer_text_win_value1_desktop",
                                    "uimode": "desktop",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "$0.0",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_text_colonSymbol44",
                                    "name": "coinContainer_text_colonSymbol44",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainerTotalWin",
                                    "name": "coinContainer_text_totalwin_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_totalWin",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },











                                {
                                    "id": "coinContainer_textOfContainer1_1",
                                    "name": "coinContainer_text_bet_label",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": false,
                                    "text": "buttonPanelText_1",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        font: '20px Oswald-SemiBold',


                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer1_2",
                                    "name": "coinContainer_text_colonSymbol3",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 12,
                                    "visible": false,
                                    "text": ":",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Arial',
                                        fontSize: 30,
                                        fontWeight: 'bold',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer1_3",
                                    "name": "coinContainer_text_bet_value",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 200,
                                    "visible": false,
                                    "text": "buttonPanelText_8",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Arial',
                                        fontSize: 30,
                                        fontWeight: 'bold',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_label_BetPanel_value",
                                    "name": "coinContainer_label_BetPanel_value",
                                    "type": "Text",
                                    "x": 0,
                                    "y": 0,
                                    "width": 100,
                                    "visible": false,
                                    "text": "$1.20",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Arial',
                                        fontSize: 30,
                                        fontWeight: 'bold',
                                        fill: ['#ffffff'],
                                    },
                                },













                            ]

                        },


                        {
                            id: "container_label_coins_portrait",
                            "name": "container_label_coins_portrait",
                            "type": "Container",
                            "class": "",
                            "visible": false,
                            "messageInLoop": true,
                            "x": -433,
                            "y": 1780,
                            "width": 0,
                            "height": 0,
                            "filterTypes": [],
                            child: [

                                {
                                    "id": "coinContainer_textOfContainer1_1",
                                    "name": "coinContainer_text_bet_label",
                                    "type": "Text",
                                    "x": 1362,
                                    "y": 30,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_1",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                //  {
                                //      "id": "coinContainer_textOfContainer1_2",
                                //      "name": "coinContainer_text_colonSymbol1",
                                //      "type": "Text",
                                //      "x": 1391,
                                //      "y": -2,
                                //      "width": 12,
                                //      "visible": true,
                                //      "text": "|",
                                //      "scaleToFit": true,
                                //      "anchor": [0.5, 0.5],
                                //      "textStyle": {
                                //          fontFamily: 'Oswald-SemiBold',
                                //          fontSize: 20,
                                //          fontStyle: 'normal',
                                //          fill: ['#ffffff'],
                                //      },
                                //      "parentLayer": "specialAnimationLayer",
                                //  },
                                {
                                    "id": "coinContainer_textOfContainer1_3",
                                    "name": "coinContainer_text_total_bet_value_Portrait",
                                    "type": "Text",
                                    "x": 1308,
                                    "y": 30,
                                    "width": 200,
                                    "visible": true,
                                    "text": "$1.22",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_textOfContainer1_2",
                                    "name": "coinContainer_text_colonSymbol5",
                                    "type": "Text",
                                    "x": 1384,
                                    "y": 30,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_bet_coins_label",
                                    "name": "coinContainer_bet_coins_label",
                                    "type": "Text",
                                    "x": 1416,
                                    "y": 30,
                                    "width": 200,
                                    "visible": true,
                                    "text": "COINS",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_coins_separater",
                                    "name": "coinContainer_coins_separater",
                                    "type": "Text",
                                    "x": 1446,
                                    "y": 30,
                                    "width": 12,
                                    "visible": true,
                                    "text": ":",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_coins_value_text",
                                    "name": "coinContainer_coins_value_text",
                                    "type": "Text",
                                    "x": 1463,
                                    "y": 30,
                                    "width": 200,
                                    "visible": true,
                                    "text": "10",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },



                                {
                                    "id": "coinContainer_total_coins_label",
                                    "name": "coinContainer_total_coins_label",
                                    "type": "Text",
                                    "x": 472,
                                    "y": 30,
                                    "width": 146,
                                    "visible": true,
                                    "text": "COINS",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer2_5",
                                    "name": "coinContainer_text_colonSymbol4",
                                    "type": "Text",
                                    "x": 505,
                                    "y": 30,
                                    "width": 10,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer2_6",
                                    "name": "coinContainer_total_coins_value_portrait",
                                    "type": "Text",
                                    "x": 512,
                                    "y": 30,
                                    "width": 200,
                                    "visible": true,
                                    "layout": false,
                                    "uimode": "desktop",
                                    "text": "5000",
                                    "scaleToFit": true,
                                    "anchor": [0, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },


                                {
                                    "id": "coinContainer_textOfContainer1_1",
                                    "name": "coinContainer_text_bet_label",
                                    "type": "Text",
                                    "x": 900,
                                    "y": 40,
                                    "width": 200,
                                    "visible": false,
                                    "text": "buttonPanelText_1",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        font: '20px Oswald-SemiBold',


                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer1_2",
                                    "name": "coinContainer_text_colonSymbol6",
                                    "type": "Text",
                                    "x": 940,
                                    "y": 40,
                                    "width": 12,
                                    "visible": false,
                                    "text": ":",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Arial',
                                        fontSize: 30,
                                        fontWeight: 'bold',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },
                                {
                                    "id": "coinContainer_textOfContainer1_3",
                                    "name": "coinContainer_text_bet_value",
                                    "type": "Text",
                                    "x": 990,
                                    "y": 40,
                                    "width": 200,
                                    "visible": false,
                                    "text": "buttonPanelText_8",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Arial',
                                        fontSize: 30,
                                        fontWeight: 'bold',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_label_BetPanel_value",
                                    "name": "coinContainer_label_BetPanel_value",
                                    "type": "Text",
                                    "x": 275,
                                    "y": 65,
                                    "width": 100,
                                    "visible": false,
                                    "text": "$1.20",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Arial',
                                        fontSize: 30,
                                        fontWeight: 'bold',
                                        fill: ['#ffffff'],
                                    },
                                },

                                {
                                    "id": "coinContainer_textOfContainerTotalWin",
                                    "name": "coinContainer_text_totalwin_label_Portrait",
                                    "type": "Text",
                                    "x": 870,
                                    "y": 100,
                                    "width": 200,
                                    "visible": true,
                                    "text": "buttonPanelText_totalWin",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_textOfContainer1_2",
                                    "name": "coinContainer_text_colonSymbol1_portrait",
                                    "type": "Text",
                                    "x": 923,
                                    "y": 100,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_text_6",
                                    "name": "coinContainer_text_win_value1",
                                    "uimode": "desktop",
                                    "type": "Text",
                                    "x": 960,
                                    "y": 100,
                                    "width": 200,
                                    "visible": true,
                                    "text": "$0.00",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_totalCoinwinSeparater",
                                    "name": "coinContainer_totalCoinwinSeparater2",
                                    "type": "Text",
                                    "x": 995,
                                    "y": 100,
                                    "width": 12,
                                    "visible": true,
                                    "text": "|",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_coinWinText",
                                    "name": "coinContainer_coinWinText_portrait",
                                    "type": "Text",
                                    "x": 1030,
                                    "y": 100,
                                    "width": 200,
                                    "visible": true,
                                    "text": "COINS",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_totalCoinwincolon",
                                    "name": "coinContainer_totalCoinwincolon_portrait",
                                    "type": "Text",
                                    "x": 1060,
                                    "y": 100,
                                    "width": 12,
                                    "visible": true,
                                    "text": ":",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 20,
                                        fontStyle: 'normal',
                                        fill: ['#999999'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                                {
                                    "id": "coinContainer_text_6",
                                    "name": "coinContainer_coin_win_value1",
                                    "uimode": "desktop",
                                    "type": "Text",
                                    "x": 1080,
                                    "y": 100,
                                    "width": 200,
                                    "visible": true,
                                    "text": "0",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        fontFamily: 'Oswald-SemiBold',
                                        fontSize: 22,
                                        fontStyle: 'normal',
                                        fill: ['#ffffff'],
                                    },
                                    "parentLayer": "specialAnimationLayer",
                                },

                            ]

                        },
                        {
                            "name": "backgroundGraphic_for_insufficientFunds",
                            "type": "Graphic",
                            "shape": "rectangle",
                            "visible": false,
                            "alpha": 0.8,
                            "color": "0x242424",
                            "x": 448,
                            "y": 498,
                            "width": 1020,
                            "height": 80,
                        },
                        {
                            "id": "insufficientFunds",
                            "name": "insufficientFunds",
                            "type": "Text",
                            "layout": true,
                            "x": 963,
                            "y": 536,
                            "width": 1050,
                            "visible": false,
                            "text": "insuffFunds",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Oswald-SemiBold',
                                fontSize: 52,
                                fontStyle: 'normal',
                                fill: ['#ffffff'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "buyFeatureStakeExceeds",
                            "name": "buyFeatureStakeExceeds",
                            "type": "Text",
                            "layout": false,
                            "uimode": "desktop",
                            "x": 963,
                            "y": 1062,
                            "width": 500,
                            "visible": false,
                            "text": "buyStakeExceed",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Oswald-SemiBold',
                                fontSize: 22,
                                fontStyle: 'normal',
                                fill: ['#ffffff'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                        {
                            "id": "buyFeatureStakeExceeds",
                            "name": "buyFeatureStakeExceeds",
                            "type": "Text",
                            "layout": true,
                            "uimode": "mobile",
                            "x": 963,
                            "y": 1062,
                            "width": 500,
                            "visible": false,
                            "text": "buyStakeExceed",
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Oswald-SemiBold',
                                fontSize: 22,
                                fontStyle: 'normal',
                                fill: ['#ffffff'],
                            },
                            "parentLayer": "specialAnimationLayer",
                        },
                    ]
                },
                /*  {
                     "id": "BuyFeature",
                     "name": "BuyFeature",
                     "type": "Tag",
                     "class": "",
                     "parentLayer": "specialAnimationLayer",
                     "filterTypes": [],
                     child: []
                 }, */
                {
                    "id": "multiplierContainerTag",
                    "name": "Multiplier",
                    "type": "Tag",
                    "class": "",
                    "parentLayer": "specialAnimationLayer",
                    "filterTypes": [],
                    child: []
                },
                {
                    "id": "winCelebrationContainerTag",
                    "name": "WinCelebration",
                    "type": "Tag",
                    "class": "",
                    "parentLayer": "specialAnimationLayer",
                    "filterTypes": [],
                    child: []
                },
                {
                    "id": "winCelebrationContainerTag",
                    "name": "WinCelebration",
                    "type": "Tag",
                    "class": "",
                    "parentLayer": "specialAnimationLayer",
                    "filterTypes": [],
                    child: []
                },
            ]
        }


    ]

}